import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        Questions?{" "}
        <a href="mailto:valuations@mlincsolutions.com" className="footer-link">
          Email us at valuations@mlincsolutions.com
        </a>
      </p>
      <p>© {new Date().getFullYear()} MLinc Solutions. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
